import { Controller } from "@hotwired/stimulus"

// Contrôleur simple pour les onglets (tabs)
// Chaque onglet a ce contrôleur et déclenche l'action toggle
export default class extends Controller {
  static values = { id: String }

  toggle(event) {
    event.preventDefault()

    const targetId = this.idValue || event.currentTarget.dataset.toggleIdValue
    if (!targetId) return

    this.activateTab(targetId)
  }

  // Méthode pour activer un onglet depuis n'importe quel élément (ex: stat cards)
  switchTo(event) {
    event.preventDefault()

    const targetId = event.currentTarget.dataset.toggleTargetValue
    if (!targetId) return

    this.activateTab(targetId)
  }

  activateTab(targetId) {
    // Trouver tous les onglets et contenus dans le document
    const tabs = document.querySelectorAll('[data-toggle-id-value]')
    const contents = document.querySelectorAll('.tab-content')

    // Désactiver tous les onglets
    tabs.forEach(tab => {
      tab.classList.remove('border-blue-500', 'text-blue-600')
      tab.classList.add('border-transparent', 'text-gray-500')
    })

    // Cacher tous les contenus
    contents.forEach(content => {
      content.classList.add('hidden')
    })

    // Trouver et activer l'onglet correspondant
    const targetTab = document.querySelector(`[data-toggle-id-value="${targetId}"]`)
    if (targetTab) {
      targetTab.classList.remove('border-transparent', 'text-gray-500')
      targetTab.classList.add('border-blue-500', 'text-blue-600')
    }

    // Afficher le contenu correspondant
    const targetContent = document.getElementById(targetId)
    if (targetContent) {
      targetContent.classList.remove('hidden')
    }
  }
}
